module.exports = __webpack_public_path__ + "img/hic-diabetes-mellitus-female.af905441.png";